import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { BranchesImplRepository } from './branches-imp.respository';
import { BranchesRepository } from '@/core/domain/branches/repositories/branches.repository';
import { FindBranchesUseCase } from '@/core/domain/branches/usecases/findBranches.usecase';

const findBranchesUseCaseFactory = (branchesRepository: BranchesRepository) =>
    new FindBranchesUseCase(branchesRepository);

@NgModule({
    imports: [CommonModule],
    providers: [
        {
            provide: FindBranchesUseCase,
            useFactory: findBranchesUseCaseFactory,
            deps: [BranchesImplRepository],
        },
        {
            provide: BranchesRepository,
            useClass: BranchesImplRepository,
        },
    ],
})
export class BranchesModule {}
